import { Stack, usePathname } from 'expo-router';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { PromoMessageRibbon } from 'pages/loyalty/loyalty-promo-message-ribbon';
import { primitive } from 'styles/constants/primitives';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function RewardsLayout() {
  const pathname = usePathname();

  const isIncentiveSelected = pathname && !!pathname.split('/')[3];

  return (
    <>
      {!isIncentiveSelected && <PromoMessageRibbon />}
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: primitive.bk.$mayoEggWhite },
        }}
      >
        <Stack.Screen name="index" options={{ animation: 'none' }} />
        <Stack.Screen name="history" options={{ animation: 'none' }} />
        <Stack.Screen name="activate-challenge" />
        {/* NOTE: modals are in (modals) */}
      </Stack>
      <FloatingViewCartFab />
    </>
  );
}
